export const TOING_HEADER_BANNER_ANIMATION_SEEN_SESSION_KEY = "toing_header_banner_animation_seen";

export const TOING_HEADER_BANNER_SLIDE_UP_DURATION_MS = 500;
export const TOING_HEADER_BANNER_SLIDE_UP_DELAY_MS = 500;
export const TOING_HEADER_BANNER_SLIDE_UP_CLIP_WINDOW_MS =
    TOING_HEADER_BANNER_SLIDE_UP_DELAY_MS + TOING_HEADER_BANNER_SLIDE_UP_DURATION_MS;
